module.exports = __webpack_public_path__ + "img/0324image1.d769cd5e.png";